<div class="custom-input-container" [ngClass]="[size, error ? 'error' : '']">

  @if (label) {
    <label [for]="inputId" class="input-label">{{ label }}@if (isRequired) {<span class="required-mark" aria-hidden="true">*</span>}</label>
  }

  <!-- Input with Left Icon -->
  @if (icon && iconPosition === 'left') {
    <p-iconfield iconPosition="left">
      <p-inputicon [styleClass]="'pi pi-' + icon"></p-inputicon>
      <input
        #inputRef
        pInputText
        [attr.type]="nativeType"
        [attr.inputmode]="nativeInputMode"
        [attr.pattern]="decimalPattern"
        [attr.spellcheck]="type === 'decimal' ? 'false' : null"
        [attr.data-decimal]="type === 'decimal' ? true : null"
        [attr.step]="step ?? null"
        [attr.min]="min ?? null"
        [placeholder]="placeholder"
        [value]="displayValue"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-invalid]="error ? 'true' : null"
        [attr.aria-describedby]="describedBy"
        class="custom-input"
        [id]="inputId"
      />
      @if (type === 'decimal') {
        <span class="decimal-stepper">
          <button type="button" tabindex="-1" aria-label="Incrementar valor" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="stepDecimal(1)">▲</button>
          <button type="button" tabindex="-1" aria-label="Reducir valor" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="stepDecimal(-1)">▼</button>
        </span>
      }
    </p-iconfield>
  }

  <!-- Input with Right Icon -->
  @if (icon && iconPosition === 'right') {
    <p-iconfield iconPosition="right">
      <input
        #inputRef
        pInputText
        [attr.type]="nativeType"
        [attr.inputmode]="nativeInputMode"
        [attr.pattern]="decimalPattern"
        [attr.spellcheck]="type === 'decimal' ? 'false' : null"
        [attr.data-decimal]="type === 'decimal' ? true : null"
        [attr.step]="step ?? null"
        [attr.min]="min ?? null"
        [placeholder]="placeholder"
        [value]="displayValue"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-invalid]="error ? 'true' : null"
        [attr.aria-describedby]="describedBy"
        class="custom-input"
        [id]="inputId"
      />
      <p-inputicon [styleClass]="'pi pi-' + icon"></p-inputicon>
      @if (type === 'decimal') {
        <span class="decimal-stepper">
          <button type="button" tabindex="-1" aria-label="Incrementar valor" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="stepDecimal(1)">▲</button>
          <button type="button" tabindex="-1" aria-label="Reducir valor" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="stepDecimal(-1)">▼</button>
        </span>
      }
    </p-iconfield>
  }

  <!-- Input without Icon -->
  @if (!icon) {
    <p-iconfield>
      <input
        #inputRef
        pInputText
        [attr.type]="nativeType"
        [attr.inputmode]="nativeInputMode"
        [attr.pattern]="decimalPattern"
        [attr.spellcheck]="type === 'decimal' ? 'false' : null"
        [attr.data-decimal]="type === 'decimal' ? true : null"
        [attr.step]="step ?? null"
        [attr.min]="min ?? null"
        [placeholder]="placeholder"
        [value]="displayValue"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-invalid]="error ? 'true' : null"
        [attr.aria-describedby]="describedBy"
        class="custom-input custom-input-witout-icon"
        [id]="inputId"
      />
      <ng-container *ngTemplateOutlet="suffix"></ng-container>
      @if (type === 'decimal') {
        <span class="decimal-stepper">
          <button type="button" tabindex="-1" aria-label="Incrementar valor" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="stepDecimal(1)">▲</button>
          <button type="button" tabindex="-1" aria-label="Reducir valor" [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="stepDecimal(-1)">▼</button>
        </span>
      }
    </p-iconfield>
  }

  <!-- Error Message -->
  @if (error) {
    <div class="error-message" [id]="errorId" role="alert">{{ errorMessage }}</div>
  }

  <!-- Helper Text -->
  @if (helperText) {
    <div class="helper-text" [id]="helperId">{{ helperText }}</div>
  }

</div>
